import { render, staticRenderFns } from "./BtnLayout.vue?vue&type=template&id=8cbc2c6c&scoped=true&"
import script from "./BtnLayout.vue?vue&type=script&lang=js&"
export * from "./BtnLayout.vue?vue&type=script&lang=js&"
import style0 from "./BtnLayout.vue?vue&type=style&index=0&id=8cbc2c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbc2c6c",
  null
  
)

export default component.exports